import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	standalone: true,
	imports: [CommonModule],
	templateUrl: './inicio.view.html',
	styleUrls: ['./inicio.view.scss'],
	host: {
		'data-view-id': 'inicio-view'
	}
})
export class InicioView {}
